import { useQuery } from '@tanstack/react-query';

import { useApiClient } from './useApiClient';

export function useQueryAccounts() {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['accounts'],
    queryFn: () => apiClient.accountClient.getAllAccounts(),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
